export const defaultOptionsSetting = {
    width: 'resolve',
    templateResult: (option) => {
        const {element, text} = option;

        if($(element).data('trashed') === 1) return null;

        return text;
    },
}
